import '@arco-design/web-react/dist/css/arco.css'

import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'core-js/features/object/set-prototype-of'
import 'core-js/features/function/name'

import React, { StrictMode } from 'react'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom'
import { getStore, imagexConfig, env } from 'UTILS'
import { BrowserRouter } from 'react-router-dom'
import { loadableReady } from '@loadable/component'
import { PersistGate } from 'redux-persist/integration/react'
import ImageObserver from 'image-observer-uni'
import HeifDecoder from 'image-observer-heif'
import AvifDecoder from 'image-observer-avif'
import Logger from '@byted/image-observer-logger'
import App from './App'
import { Message } from '@arco-design/web-react'
import CatchErrorProvider from 'UTILS/CatchErrorProvider'
import { serviceQuality } from '@byted-vcloud/exp-lite-slardar'
import { SlardarEventType } from './constants'
import uuid from 'UTILS/uuid'

interface OberverInfo {
  uri: string
  file_size: number
  image_type: string
  http_status: number
  code: number
  duration: number
  headersString: string[]
  log_channel: string
  err_code: string
}

const { store, persistor } = getStore()

const initImageSDK = async () => {
  const observer = new ImageObserver({
    logger: {
      user_unique_id: uuid(),
      app_id: imagexConfig.appid,
    },
    plugins: [Logger, HeifDecoder, AvifDecoder],
    'imageObserver-heif-decoder': {
      threads: 3,
      colorMode: 1,
    },
    render: {
      forceUseImg: true,
      keepImgExist: true,
      keepImgExistClassName: 'hiddenImg',
      dispatchEventName: 'load',
    },
    'imageObserver-canvas-render': {
      singleCanvasInstance: true,
    },
    codec: {
      forceSoftCodec: false,
      forceHardCodec: false,
    },
    divider: {
      dataSrc: 'data-src',
      debug: !env.isProd,
      srcObserver: true,
      disabledVoidImg: true,
      selector: 'img.img',
      beforeSendLog: (info: OberverInfo) => {
        if (typeof info?.code === 'number') {
          const {
            uri,
            file_size,
            image_type,
            http_status,
            code,
            duration,
            headersString,
            log_channel,
            err_code,
          } = info
          serviceQuality({
            taskType: SlardarEventType.ImageLoad,
            success: info.code === 0 ? true : false,
            customInfo: {
              uri,
              file_size,
              image_type,
              http_status,
              code,
              err_code,
              duration,
              headersString,
              log_channel,
            },
          })
        }
      },
    },
    requester: {
      timeout: 1000000,
      errorHandle: () => {
        Message.error('图片加载失败')
      },
    },
  })
  await (observer as any).start()
  ;(window as any).jobs = {}
  return true
}

const Application = (
  <StrictMode>
    <Provider store={store}>
      <CatchErrorProvider>
        <BrowserRouter>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </BrowserRouter>
      </CatchErrorProvider>
    </Provider>
  </StrictMode>
)
const root = document.getElementById('root')

if (root) {
  loadableReady(() => {
    /* Hydrate React components when persistor has synced with redux store */
    initImageSDK().then(() => {
      ReactDOM.hydrate(Application, root)
    })
  })
}

if (env.isDev && module.hot) (module.hot as any).accept()
